export interface IOperateRecord {
  userName: string;
  taskType: string;
  buttonName: string;
  taskIds: string;
  channel: string;
  createTime: string;
  details: string;
  operateSource: number;
  operatedUserName: string;
  userId: string;
  requestIp: string;
  requestURI: string;
  requestParam: string;
}

export enum ModuleType {
  Project = "project",
  UserAuth = "userAuth",
  UserInfo = "userInfo",
  RenderingTask = "render",
  AnalysisTask = "analysis",
  Assets = "assets",
  DingtalkSubUser = "dingtalkSubUser",
  Setting = "setting",
  CloudProduce = "cloudProduce",
  All = "All",
}

export enum OperateSource {
  ALL = "",
  Main = "1",
  Sub = "2",
  AuthAdmin = "3",
  DingSub = "4",
}

export enum Channel {
  Animation = 1,
  Web = 2,
  SI = 3,
  ALL = 4,
}
